// import styled from 'styled-components';
// import { darken } from 'polished';

// /* ===== Identidade visual (alinhada ao login / Header) =====
//    --primary: #ff6d3c (gradiente)   --blue: #1789dd
//    --ink:     #2c405a   --muted: #cbd0d8 / #79869e
//    --border:  rgba(216, 224, 235, 0.9)
// =========================================================== */

// const PRIMARY_GRADIENT =
//   'linear-gradient(135deg, #ff6d3c 0%, #ff875f 52%, #ff9b78 100%)';

// export const Container = styled.div`
//   display: flex;
//   flex-direction: ${(props) => (props.search ? 'column' : 'row')};
//   margin: 0 auto;
//   width: 100%;
//   max-width: ${(props) => (props.width ? `${props.width}px` : 'auto')};
//   padding: 10px 0;

//   #btn-back {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     min-height: 45px;
//     padding: 0 10px;
//     margin-right: 10px;
//     border: none;
//     border-radius: 12px;
//     background: none;
//     color: #79869e;
//     cursor: pointer;
//     transition: background 0.2s ease, color 0.2s ease;

//     :hover {
//       background: rgba(255, 109, 60, 0.1);
//       color: #ff6d3c;
//     }
//   }
// `;

// export const Wrapper = styled.div`
//   flex: 1;
//   display: flex;
//   flex-direction: row;
//   align-items: center;
// `;

// export const PaginationWrapper = styled(Wrapper)`
//   padding: 5px;
//   height: 100%;
// `;

// export const TitleWrapper = styled.div`
//   flex-direction: column;

//   & * {
//     flex: 1;
//     color: #2c405a;
//     padding: 10px 0;
//   }
// `;

// export const Title = styled.h1`
//   font-size: 22px;
//   letter-spacing: -0.4px;
//   color: ${(props) => props.theme.color};
// `;

// export const Subtitle = styled.strong`
//   font-size: 14px;
//   color: #79869e;
// `;

// export const Action = styled.div`
//   display: flex;
//   align-items: center;
//   flex-direction: ${(props) => (props.rowAction ? 'row-reverse' : 'row')};

//   > a {
//     width: 150px;
//     margin: 0 10px;
//     padding: 5px;
//     border: 1px solid rgba(216, 224, 235, 0.9);
//     border-radius: 12px;
//     text-align: center;
//     color: #fff;
//     font-weight: bold;
//   }

//   > button {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     height: 42px;
//     width: 180px;
//     border: 0;
//     border-radius: 12px;
//     color: #fff;
//     font-weight: 800;
//     cursor: pointer;

//     + button {
//       margin-left: 10px;
//     }
//   }

//   #btn-next,
//   #btn-new {
//     color: #fff;
//     background: ${PRIMARY_GRADIENT};
//     box-shadow: 0 12px 26px rgba(255, 109, 60, 0.3);
//     transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;

//     &:hover {
//       transform: translateY(-1px);
//       box-shadow: 0 16px 32px rgba(255, 109, 60, 0.42);
//       filter: brightness(1.02);
//     }
//   }

//   #btn-salvar-rascunho {
//     background: #e2e8f0;
//     color: #2c405a;
//     transition: background 0.2s ease;

//     &:hover {
//       background: ${darken(0.06, '#e2e8f0')};
//     }
//   }

//   #btn-publish {
//     color: #fff;
//     background: linear-gradient(135deg, #1789dd 0%, #1063b0 100%);
//     box-shadow: 0 12px 26px rgba(16, 99, 176, 0.28);
//     transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;

//     &:hover {
//       transform: translateY(-1px);
//       box-shadow: 0 16px 32px rgba(16, 99, 176, 0.4);
//       filter: brightness(1.03);
//     }
//   }

//   #btn-back {
//     background: #b6bdca;
//     color: #fff;
//     transition: background 0.2s ease;

//     &:hover {
//       background: ${darken(0.1, '#b6bdca')};
//     }
//   }

//   #btn-submit {
//     color: #fff;
//     background: linear-gradient(135deg, #22c55e 0%, #2bd66b 100%);
//     box-shadow: 0 12px 26px rgba(34, 197, 94, 0.28);
//     transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;

//     &:hover {
//       transform: translateY(-1px);
//       box-shadow: 0 16px 32px rgba(34, 197, 94, 0.4);
//       filter: brightness(1.02);
//     }
//   }

//   #btn-upload {
//     background: none;
//     color: #1789dd;
//     font-weight: 600;
//     transition: color 0.2s ease;

//     &:hover {
//       color: ${darken(0.1, '#1789dd')};
//     }
//   }

//   #btn-excluir {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     height: 42px;
//     width: 180px;
//     margin-left: 10px;
//     border: 0;
//     border-radius: 12px;
//     color: #fff;
//     font-weight: 800;
//     cursor: pointer;
//     transition: filter 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

//     background: ${(props) => (props.isActive ? PRIMARY_GRADIENT : '#cbd0d8')};
//     box-shadow: ${(props) =>
//       props.isActive ? '0 12px 26px rgba(255, 109, 60, 0.3)' : 'none'};

//     &:hover {
//       ${(props) =>
//         props.isActive &&
//         'transform: translateY(-1px); filter: brightness(1.02);'}
//     }
//   }

//   .btn-img {
//     min-width: 0;
//     padding: 0;
//     border: 0;
//     background: none;
//     color: #cbd0d8;
//     transition: color 0.2s ease;

//     :hover {
//       color: #2c405a;
//     }
//   }
// `;

// Action.BtnDefault = styled.button`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   height: 42px;
//   width: 180px;
//   margin-left: 15px;
//   border: 0;
//   border-radius: 12px;
//   color: #fff;
//   font-weight: 800;
//   cursor: pointer;
// `;

// Action.BtnSquare = styled.button`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   height: 42px;
//   width: 50px !important;
//   border: 0;
//   border-radius: 12px;
//   cursor: pointer;

//   + button {
//     margin-left: 15px;
//   }

//   &#btn-icon-deletar,
//   &#btn-file-upload,
//   &#btn-file-download,
//   &#btn-file-print,
//   &#btn-filter {
//     background: none;
//     color: #cbd0d8;
//     transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;

//     &:hover {
//       background: rgba(23, 137, 221, 0.1);
//       color: ${darken(0.1, '#1789dd')};
//       transform: translateY(-1px);
//     }
//   }

//   &#btn-nav-prior,
//   &#btn-nav-next {
//     background: none;
//     color: #cbd0d8;
//     transition: background 0.2s ease, color 0.2s ease;

//     &:hover {
//       background: rgba(255, 109, 60, 0.1);
//       color: #ff6d3c;
//     }
//   }
// `;

// export const NotificationWrapper = styled.div`
//   position: relative;
// `;

// export const NotificationBadge = styled.span`
//   position: absolute;
//   top: -2px;
//   right: -2px;
//   width: 11px;
//   height: 11px;
//   border-radius: 50%;
//   background: #ef4444;
//   box-shadow: 0 0 0 2px #fff, 0 2px 6px rgba(239, 68, 68, 0.5);
// `;

import styled, { css } from 'styled-components';
import { darken } from 'polished';

/* ===== Identidade visual (alinhada ao login / Header) =====
   --primary: #ff6d3c (gradiente)   --blue: #1789dd
   --ink:     #2c405a   --muted: #cbd0d8 / #79869e
   --border:  rgba(216, 224, 235, 0.9)
=========================================================== */

const PRIMARY_GRADIENT =
  'linear-gradient(135deg, #ff6d3c 0%, #ff875f 52%, #ff9b78 100%)';

export const Container = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.search ? 'column' : 'row')};
  margin: 0 auto;
  width: 100%;
  max-width: ${(props) => (props.width ? `${props.width}px` : 'auto')};
  padding: 10px 0;

  #btn-back {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 45px;
    padding: 0 10px;
    margin-right: 10px;
    border: none;
    border-radius: 12px;
    background: none;
    color: #79869e;
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease;

    :hover {
      background: rgba(255, 109, 60, 0.1);
      color: #ff6d3c;
    }
  }

  /**
   * =====================================================================
   * VARIANTE COMPACTA
   * ---------------------------------------------------------------------
   * Usada nas telas do editor (Mapeamento, Edição, Extração), em que a
   * barra é só identificação e navegação — o que importa na tela é o
   * desenho e a tabela de itens. Na versão padrão a faixa consome ~66px
   * (20 de padding do container + 46 do título com recuo interno);
   * compacta ela cabe em --edt-titlebar-h.
   *
   * Os seletores por elemento (h1/strong) alcançam Title e Subtitle sem
   * precisar de component selector: TitleWrapper é declarado depois deste
   * bloco no arquivo e interpolá-lo aqui daria erro de inicialização.
   * A especificidade (.container h1) vence o "& *" do TitleWrapper.
   * =====================================================================
   */
  ${(props) =>
    props.compacto &&
    css`
      align-items: center;
      min-height: var(--edt-titlebar-h, 40px);
      padding: 0;

      #btn-back {
        min-height: 30px;
        padding: 0 6px;
        margin-right: 4px;
        border-radius: 10px;
      }

      h1,
      strong {
        padding: 0;
      }

      h1 {
        font-size: 17px;
        line-height: 1.2;
        letter-spacing: -0.2px;
      }

      strong {
        font-size: 12px;
      }
    `}
`;

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const PaginationWrapper = styled(Wrapper)`
  padding: 5px;
  height: 100%;
`;

export const TitleWrapper = styled.div`
  flex-direction: column;

  & * {
    flex: 1;
    color: #2c405a;
    padding: 10px 0;
  }
`;

export const Title = styled.h1`
  font-size: 22px;
  letter-spacing: -0.4px;
  color: ${(props) => props.theme.color};
`;

export const Subtitle = styled.strong`
  font-size: 14px;
  color: #79869e;
`;

export const Action = styled.div`
  display: flex;
  align-items: center;
  flex-direction: ${(props) => (props.rowAction ? 'row-reverse' : 'row')};

  > a {
    width: 150px;
    margin: 0 10px;
    padding: 5px;
    border: 1px solid rgba(216, 224, 235, 0.9);
    border-radius: 12px;
    text-align: center;
    color: #fff;
    font-weight: bold;
  }

  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    width: 180px;
    border: 0;
    border-radius: 12px;
    color: #fff;
    font-weight: 800;
    cursor: pointer;

    + button {
      margin-left: 10px;
    }
  }

  #btn-next,
  #btn-new {
    color: #fff;
    background: ${PRIMARY_GRADIENT};
    box-shadow: 0 12px 26px rgba(255, 109, 60, 0.3);
    transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 16px 32px rgba(255, 109, 60, 0.42);
      filter: brightness(1.02);
    }
  }

  #btn-salvar-rascunho {
    background: #e2e8f0;
    color: #2c405a;
    transition: background 0.2s ease;

    &:hover {
      background: ${darken(0.06, '#e2e8f0')};
    }
  }

  #btn-publish {
    color: #fff;
    background: linear-gradient(135deg, #1789dd 0%, #1063b0 100%);
    box-shadow: 0 12px 26px rgba(16, 99, 176, 0.28);
    transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 16px 32px rgba(16, 99, 176, 0.4);
      filter: brightness(1.03);
    }
  }

  #btn-back {
    background: #b6bdca;
    color: #fff;
    transition: background 0.2s ease;

    &:hover {
      background: ${darken(0.1, '#b6bdca')};
    }
  }

  #btn-submit {
    color: #fff;
    background: linear-gradient(135deg, #22c55e 0%, #2bd66b 100%);
    box-shadow: 0 12px 26px rgba(34, 197, 94, 0.28);
    transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 16px 32px rgba(34, 197, 94, 0.4);
      filter: brightness(1.02);
    }
  }

  #btn-upload {
    background: none;
    color: #1789dd;
    font-weight: 600;
    transition: color 0.2s ease;

    &:hover {
      color: ${darken(0.1, '#1789dd')};
    }
  }

  #btn-excluir {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    width: 180px;
    margin-left: 10px;
    border: 0;
    border-radius: 12px;
    color: #fff;
    font-weight: 800;
    cursor: pointer;
    transition: filter 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

    background: ${(props) => (props.isActive ? PRIMARY_GRADIENT : '#cbd0d8')};
    box-shadow: ${(props) =>
      props.isActive ? '0 12px 26px rgba(255, 109, 60, 0.3)' : 'none'};

    &:hover {
      ${(props) =>
        props.isActive &&
        'transform: translateY(-1px); filter: brightness(1.02);'}
    }
  }

  .btn-img {
    min-width: 0;
    padding: 0;
    border: 0;
    background: none;
    color: #cbd0d8;
    transition: color 0.2s ease;

    :hover {
      color: #2c405a;
    }
  }
`;

Action.BtnDefault = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  width: 180px;
  margin-left: 15px;
  border: 0;
  border-radius: 12px;
  color: #fff;
  font-weight: 800;
  cursor: pointer;
`;

Action.BtnSquare = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  width: 50px !important;
  border: 0;
  border-radius: 12px;
  cursor: pointer;

  + button {
    margin-left: 15px;
  }

  &#btn-icon-deletar,
  &#btn-file-upload,
  &#btn-file-download,
  &#btn-file-print,
  &#btn-filter {
    background: none;
    color: #cbd0d8;
    transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;

    &:hover {
      background: rgba(23, 137, 221, 0.1);
      color: ${darken(0.1, '#1789dd')};
      transform: translateY(-1px);
    }
  }

  &#btn-nav-prior,
  &#btn-nav-next {
    background: none;
    color: #cbd0d8;
    transition: background 0.2s ease, color 0.2s ease;

    &:hover {
      background: rgba(255, 109, 60, 0.1);
      color: #ff6d3c;
    }
  }
`;

export const NotificationWrapper = styled.div`
  position: relative;
`;

export const NotificationBadge = styled.span`
  position: absolute;
  top: -2px;
  right: -2px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #ef4444;
  box-shadow: 0 0 0 2px #fff, 0 2px 6px rgba(239, 68, 68, 0.5);
`;
